import { render, staticRenderFns } from "./CampaignInfo.vue?vue&type=template&id=90bf6194"
import script from "./CampaignInfo.vue?vue&type=script&lang=js"
export * from "./CampaignInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports